(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1119px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);


  /* 3D Wonders desktop mega-menu interaction:
     hover opens the existing mega menu, while the parent title remains a normal link. */
  const initDWHeaderHoverMenus = () => {
    if (!window.matchMedia('(min-width: 1120px)').matches) return;

    const nav = document.querySelector('.section-header .dw-nav');
    if (!nav || nav.dataset.dwHeaderHoverReady === 'true') return;
    nav.dataset.dwHeaderHoverReady = 'true';

    const menus = Array.from(nav.querySelectorAll('.dw-menu__details'));

    menus.forEach((details) => {
      let closeTimer;

      const openMenu = () => {
        window.clearTimeout(closeTimer);
        menus.forEach((other) => {
          if (other !== details) other.removeAttribute('open');
        });
        details.setAttribute('open', '');
      };

      const closeMenu = () => {
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => {
          details.removeAttribute('open');
        }, 100);
      };

      details.addEventListener('mouseenter', openMenu);
      details.addEventListener('mouseleave', closeMenu);
      details.addEventListener('focusin', openMenu);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDWHeaderHoverMenus);
  } else {
    initDWHeaderHoverMenus();
  }

  document.addEventListener('shopify:section:load', initDWHeaderHoverMenus);
  window.matchMedia('(min-width: 1120px)').addEventListener('change', (event) => {
    if (event.matches) initDWHeaderHoverMenus();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-image-text-slider]';

    function initSlider(root) {
      if (!root || root.dataset.sliderInitialized === 'true') return;

      const slides = Array.from(root.querySelectorAll('[data-slide]'));
      if (!slides.length) return;

      const viewport = root.querySelector('[data-slider-viewport]');
      const prev = root.querySelector('[data-slider-prev]');
      const next = root.querySelector('[data-slider-next]');
      const dots = Array.from(root.querySelectorAll('[data-slider-dot]'));
      const transitionSpeed = Math.max(0, Number(root.dataset.slideSpeed) || 400);
      const autoRotate = root.dataset.autoRotate === 'true';
      const changeSpeed = Math.max(1, Number(root.dataset.changeSpeed) || 5) * 1000;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let current = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
      let transitionTimer = null;
      let transitionFrame = null;
      let autoRotateTimer = null;

      const updateDots = () => {
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === current;
          dot.classList.toggle('is-active', active);
          if (active) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      };

      const prepareSlide = (index) => {
        const total = slides.length;
        if (!total) return;
        const slide = slides[(index + total) % total];
        const image = slide?.querySelector('img.it-slider__image');
        if (!image) return;

        image.loading = 'eager';
        image.decoding = 'async';
        if (typeof image.decode === 'function') {
          image.decode().catch(() => {});
        }
      };

      const finishTransition = () => {
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === current;
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
          slide.classList.remove('is-entering', 'is-leaving', 'from-left', 'from-right', 'to-left', 'to-right');
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        if (viewport) viewport.style.height = '';
        prepareSlide(current + 1);
        prepareSlide(current - 1);
      };

      const showSlide = (index, direction = 0, immediate = false) => {
        const total = slides.length;
        const target = (index + total) % total;

        if (target === current && !immediate) return;

        window.clearTimeout(transitionTimer);
        if (transitionFrame) cancelAnimationFrame(transitionFrame);

        if (immediate || reducedMotion || transitionSpeed === 0) {
          current = target;
          finishTransition();
          updateDots();
          return;
        }

        const outgoing = slides[current];
        const incoming = slides[target];
        const moveForward = direction !== 0 ? direction > 0 : target > current;
        const startHeight = outgoing.getBoundingClientRect().height;

        prepareSlide(target);
        incoming.hidden = false;
        incoming.classList.remove('is-active', 'is-leaving', 'to-left', 'to-right');
        incoming.classList.add('is-entering', moveForward ? 'from-right' : 'from-left');
        incoming.setAttribute('aria-hidden', 'false');

        outgoing.hidden = false;
        outgoing.classList.remove('is-entering', 'is-leaving', 'from-left', 'from-right', 'to-left', 'to-right');
        outgoing.classList.add('is-active');
        outgoing.setAttribute('aria-hidden', 'false');

        const targetHeight = incoming.scrollHeight || incoming.getBoundingClientRect().height;

        if (viewport) {
          viewport.style.height = `${startHeight}px`;
        }

        // Start both outgoing and incoming animations on the same painted frame.
        transitionFrame = requestAnimationFrame(() => {
          if (viewport && targetHeight > 0) {
            viewport.style.height = `${targetHeight}px`;
          }

          outgoing.classList.remove('is-active');
          outgoing.classList.add('is-leaving', moveForward ? 'to-left' : 'to-right');
          outgoing.setAttribute('aria-hidden', 'true');

          incoming.classList.remove('is-entering', 'from-left', 'from-right');
          incoming.classList.add('is-active');

          current = target;
          updateDots();

          transitionTimer = window.setTimeout(finishTransition, transitionSpeed + 70);
        });
      };

      const stopAutoRotate = () => {
        window.clearInterval(autoRotateTimer);
        autoRotateTimer = null;
      };

      const startAutoRotate = () => {
        stopAutoRotate();
        if (!autoRotate || slides.length < 2 || reducedMotion) return;
        autoRotateTimer = window.setInterval(() => showSlide(current + 1, 1), changeSpeed);
      };

      const restartAutoRotate = () => {
        if (!autoRotate) return;
        startAutoRotate();
      };

      prev?.addEventListener('click', () => {
        showSlide(current - 1, -1);
        restartAutoRotate();
      });

      next?.addEventListener('click', () => {
        showSlide(current + 1, 1);
        restartAutoRotate();
      });

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const target = Number(dot.dataset.sliderDot);
          showSlide(target, target >= current ? 1 : -1);
          restartAutoRotate();
        });
      });

      let touchStartX = 0;
      let touchStartY = 0;
      let isTouchTracking = false;

      viewport?.addEventListener('touchstart', (event) => {
        if (window.innerWidth > 749 || event.touches.length !== 1) return;

        const touch = event.touches[0];
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
        isTouchTracking = true;
        stopAutoRotate();
      }, { passive: true });

      viewport?.addEventListener('touchend', (event) => {
        if (!isTouchTracking) return;

        isTouchTracking = false;

        if (window.innerWidth > 749 || event.changedTouches.length !== 1) {
          restartAutoRotate();
          return;
        }

        const touch = event.changedTouches[0];
        const deltaX = touch.clientX - touchStartX;
        const deltaY = touch.clientY - touchStartY;
        const horizontalDistance = Math.abs(deltaX);
        const verticalDistance = Math.abs(deltaY);

        if (horizontalDistance >= 50 && horizontalDistance > verticalDistance * 1.25) {
          const direction = deltaX < 0 ? 1 : -1;
          showSlide(current + direction, direction);
        }

        restartAutoRotate();
      }, { passive: true });

      viewport?.addEventListener('touchcancel', () => {
        if (!isTouchTracking) return;
        isTouchTracking = false;
        restartAutoRotate();
      }, { passive: true });

      root.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          showSlide(current - 1, -1);
          restartAutoRotate();
        }
        if (event.key === 'ArrowRight') {
          showSlide(current + 1, 1);
          restartAutoRotate();
        }
      });

      root.addEventListener('mouseenter', stopAutoRotate);
      root.addEventListener('mouseleave', startAutoRotate);
      root.addEventListener('focusin', stopAutoRotate);
      root.addEventListener('focusout', startAutoRotate);

      root._imageTextSliderShow = (index) => showSlide(index, index >= current ? 1 : -1);
      root._imageTextSliderStopAutoRotate = stopAutoRotate;
      root.dataset.sliderInitialized = 'true';

      showSlide(current, 0, true);
      startAutoRotate();
    }

    function initAll(scope = document) {
      if (scope.matches?.(selector)) initSlider(scope);
      scope.querySelectorAll?.(selector).forEach(initSlider);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initAll(event.target);
    });

    document.addEventListener('shopify:block:select', (event) => {
      const slide = event.target.closest?.('[data-slide]');
      const root = slide?.closest(selector);
      if (!slide || !root) return;

      initSlider(root);
      root._imageTextSliderStopAutoRotate?.();
      const slides = Array.from(root.querySelectorAll('[data-slide]'));
      const index = slides.indexOf(slide);
      if (index >= 0) root._imageTextSliderShow?.(index);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
